<template>
  <div class="mx-4">
    <div
      class="row py-4 border-bottom min-vh-70 d-flex flex-column flex-md-row"
    >
      <div class="col">
        <div class="d-flex justify-content-start align-items-center">
          <icon-view
            class="w-auto"
            icon="fa fa-tasks-alt"
            icon-background="#fff"
            icon-color="#F3AA1C"
            variant="icon-view-size"
          />
          <span class="color-black-1' font-18 font-weight-bold">
            {{ $t('Tesis') }}
          </span>
        </div>
      </div>
      <div class="col d-flex justify-content-end mr-3">
        <action-button
          :text="$t('GoBack')"
          class="warning outline-warning px-4 py-2 mr-2"
          i="fa fa-arrow-circle-left"
          @click="goToHomeHandler"
        />
        <action-button
          :text="$t('Save')"
          class="btn-success px-4 py-2 mr-2 mx-2"
          i="fa fa-save"
          @click="onSaveHandler"
        />
      </div>
    </div>
    <div class="row py-4 pl-4">
      <div class="col-md-12">
        <div class="font-14 font-weight-bold">
          <span class="color-orange-light-2 mr-2">
            {{ $t('DocumentationTesis') }}
            <span class="align-sub">* * *</span>
          </span>
          <span class="color-dark-blue">
            {{ $t('SpecifiyAdditionalInformation') }}
          </span>
        </div>
      </div>
      <div class="col-12 pt-4">
        <CustomTextArea
          :label="$t('TitleOfTesis')"
          class="w-100 font-weight-bold color-dark-blue"
          :maxlength="3000"
          :showCharCount="true"
        />
      </div>
      <div class="col-12 pt-4">
        <custom-drop-down
          v-model="yearOfPublish"
          :label="$t('YearOfPublish')"
          placeholder="Seleccione"
          :options="years"
          fieldkey="id"
          fieldname="name"
          class="custom-dropdown__extended w-100"
          :clearable="false"
        />
      </div>
      <div class="col-12 pt-4">
        <CustomTextArea
          :label="$t('Sinopsis')"
          class="w-100 font-weight-bold color-dark-blue"
          :maxlength="3000"
          :showCharCount="true"
        />
      </div>
      <div class="col-12 pt-4">
        <AttachmentDocument
          ref="documentRef"
          :documents="documentMappedList"
          @on-refresh-document="$emit('on-refresh-document')"
        />
      </div>
      <div
        class="col d-flex mt-3 mt-3 p-3 warning"
        style="background-color: #ffc107"
      >
        <toggle-button
          sync
          :color="{ checked: 'white' }"
          v-model="authorized"
          @input="onToggleHandler"
          :switch-color="{ checked: 'gray' }"
          ref="searchAllInput"
        />
        <span class="color-white font-14 font-weight-bold pr-2 mx-2">
          Autorizar Publicación en la Biblioteca Virtual
        </span>
      </div>
    </div>
  </div>
</template>

<script>
//components
import IconView from 'icon-view';
import ActionButton from 'ActionButton';
import CustomTextArea from 'CustomTextArea';
import AttachmentDocument from '@/views/request/components/AttachmentDocument.vue';
import CustomDropDown from 'custom-drop-down';

//services
import {
  getRequest as _getRequest,
  submitRequest as _submitRequest,
} from '@/services/app.api.js';
import { i18n } from '@/i18n';

//utils
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin';
//vuex types
import types from '@/store/modules/app/types.js';

export default {
  name: 'Tesis',
  mixins: [alertMixin],
  components: {
    IconView,
    ActionButton,
    CustomTextArea,
    AttachmentDocument,
    CustomDropDown,
  },
  watch: {},
  data: () => ({
    tabId: null,
    requestInfo: {},
    enabled: true,
    authorized: false,
    yearOfPublish: null,
    years: [],
  }),
  computed: {
    businessId() {
      return this.$route.params.businessId;
    },
    isReadOnly() {
      return !this.enabled;
    },
    documentMappedList() {
      //DEMO purpose (change in implementation)
      return [
        {
          id: 0,
          documentCategoryCode: 'Tesis',
          documentCategoryName: 'Documento',
          documentId: undefined,
          filename: undefined,
          hiddenPublic: true,
        },
        {
          id: 0,
          documentCategoryCode: 'Tesis',
          documentCategoryName: 'Documento',
          documentId: '32323',
          filename: 'Documento Cargado',
          hiddenPublic: true,
        },
      ];
      /*
            if (this.info === undefined) return [];

            const documents = this.info.documents ?? [];
            const requiredDocumentCategories =
                this.info.requiredDocumentCategories ?? [];

            var selectedDocuments = this.model.selectedLetters?.map((item) => {
                const document = documents.find((d) => d.documentCategoryId === item);
                return {
                    id: item,
                    documentCategoryCode:
                        this.options.find((x) => x.id === item)?.name ?? '',
                    documentCategoryName: attachmentCategoryDescriptions[item],
                    documentId: document?.documentId,
                    filename: document?.filename,
                    hiddenPublic: true,
                };
            });

            var documentCategories = requiredDocumentCategories.map((item) => {
                const document = documents.find(
                    (d) => d.documentCategoryId === item.documentCategoryId
                );
                return {
                    id: item.documentCategoryId,
                    documentCategoryName: item.documentCategoryName,
                    documentId: document?.documentId,
                    filename: document?.filename,
                    isPublic: document?.isPublic,
                };
            });

            var result = [...selectedDocuments, ...documentCategories];
            return result;*/
    },
  },
  async mounted() {
    await this.getRequestInfo();
  },
  methods: {
    async getRequestInfo() {
      if (this.businessId) {
        this.requestInfo = (await _getRequest(this.businessId)).data;
        this.initializeSitemapInfo();
        this[types.SET_ITEM_MODEL](this.requestInfo);
      }
    },
    initializeSitemapInfo() {
      this[types.SET_SITEMAP_INFO]({
        routes: [
          i18n.t('Home'),
          `${i18n.t('ApplicationHeader.HeaderText')} #${this.businessId}`,
        ],
        request: {
          requestStatusId: this.requestInfo?.requestStatusId,
          requestStatusName: this.requestInfo?.requestStatusName,
          requestNumber: this.requestInfo?.requestNumber,
        },
      });
    },
    goToHomeHandler() {
      this.$router.replace('/');
    },
    async onSaveHandler() {
      const isValid = await this.validateAllSteps();
      if (!isValid) return;

      let saveResponse = await this.onSave();

      if (saveResponse) {
        this.ShowToast(
          'Proceso exitoso',
          'El caso ha sido actualizado exitosamente.',
          'success'
        );
        await this.getRequestInfo();
      }
    },

    async onRefreshHandler() {
      await this.getRequestInfo();
    },
    // async onDownloadRequestReportHandler() {
    //   if (this.businessId) {
    //     const response = await getInvestigationRequestReport(
    //       this.businessId,
    //       this.isEnLang
    //     ).catch((error) => {
    //       this.ShowToast('', error.response.data.message, 'error');
    //     });
    //     if (response?.data) {
    //       convertToBlob(response.data);
    //     }
    //   }
    // },
    async onSubmitRequestHandler() {
      if (this.itemId) {
        const isValid = await this.validateAllSteps(false);
        if (!isValid) return;

        const answer = await this.ShowCancelModal(
          i18n.t('ucMessagebox.TitleText').toUpperCase(),
          i18n.t('question-save-modal-title'),
          i18n.t('modal-yes-text'),
          i18n.t('btnCancel.Text')
        );

        if (answer) {
          let saveRequest = await this.onSave();
          if (!saveRequest) return;

          const { data: saveResponse } = await _submitRequest(
            this.itemId
          ).catch((error) => {
            this.ShowToast('', error.response.data.message, 'error');
          });

          if (saveResponse) {
            this.ShowToast(
              i18n.t('ProcessSuccessfully'),
              i18n.t('success-modal-title'),
              'success'
            );
            this.tabId = 0; // Move to first tab
            await this.getRequestInfo();

            // Show rating survey
            this.onOpenRatingSurveyModal();
          }
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/scss/components/action-button/index.scss';
@import '@/scss/bootstrap/_colors.scss';
@import '~vue2-editor/dist/vue2-editor.css';

.icon-view-size ::v-deep {
  width: auto !important;

  .dot {
    width: 35px !important;
    height: 35px !important;

    .title-icon {
      font-size: 15px !important;
    }
  }
}

.char-count {
  float: right;
}
.v-switch-button {
  background-color: gray !important;
}
</style>
